module.exports = __webpack_public_path__ + "static/media/mail-white.ae73c1cf.svg";